<template>
  <div class="absolute bg-white rounded shadow p-2">
    <h4 class="text-xs text-gray-600 font-normal mb-2">{{$t('air.quality')}}</h4>
    <div class="gradient h-2 my-1"></div>
    <div class="flex whitespace-no-wrap text-xs text-gray-800 font-semibold">
      <span class="flex-1">{{$t('air.level.6')}}</span>
      <span class="flex-1 ml-10">{{$t('air.level.1')}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapLegend',
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables";

.gradient {
  background-image: linear-gradient(to right, $quality6, $quality5, $quality4, $quality3, $quality2, $quality1);
}

.absolute {
  z-index: 2;
  left: 10px;
  bottom: 24px;
}
</style>
